import { Fab } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledParagraph = styled('p')(({ theme }) => ({
  fontSize: '0.8em',
  color: theme.palette.error.main,
}));

export const StyledFab = styled(Fab)(() => ({
  '&&': {
    marginLeft: '0.7em',
    marginTop: '0.7em',
  },
}));
